import { render, staticRenderFns } from "./DashboardComercial.vue?vue&type=template&id=447f58c0&"
import script from "./DashboardComercial.vue?vue&type=script&lang=js&"
export * from "./DashboardComercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\06.04\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('447f58c0')) {
      api.createRecord('447f58c0', component.options)
    } else {
      api.reload('447f58c0', component.options)
    }
    module.hot.accept("./DashboardComercial.vue?vue&type=template&id=447f58c0&", function () {
      api.rerender('447f58c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Comercial/DashboardComercial.vue"
export default component.exports